const BottomSheet = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 dark:bg-black/60 z-50 flex justify-center items-end !mt-0"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-darkBackground w-full rounded-t-3xl p-4 h-[95%] overflow-y-auto border-t border-gray-200 dark:border-neutral-800 text-black dark:text-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default BottomSheet;